export interface PayUCheckoutData {
  gateway: 'payu';
  action: string;
  params: Record<string, string | number | null | undefined>;
}

export function buildPayUFormHtml(data: PayUCheckoutData): string {
  const inputs = Object.entries(data.params)
    .filter(([, v]) => v !== null && v !== undefined)
    .map(([k, v]) => {
      const safeKey = escapeAttr(String(k));
      const safeValue = escapeAttr(String(v));
      return `<input type="hidden" name="${safeKey}" value="${safeValue}" />`;
    })
    .join('\n    ');

  return `<!doctype html>
<html>
<head><meta charset="utf-8"><title>Redirecting to PayU…</title></head>
<body style="font-family:system-ui,-apple-system,sans-serif;text-align:center;padding:80px 20px;color:#475569">
  <p style="font-size:14px">Redirecting to PayU, please wait…</p>
  <form id="payu-form" method="POST" action="${escapeAttr(data.action)}">
    ${inputs}
  </form>
  <script>document.getElementById('payu-form').submit();</script>
</body>
</html>`;
}

export function buildPayUFormElement(
  data: PayUCheckoutData,
  doc: Document = document
): HTMLFormElement {
  const form = doc.createElement('form');
  form.method = 'POST';
  form.action = data.action;
  form.style.display = 'none';

  for (const [k, v] of Object.entries(data.params)) {
    if (v === null || v === undefined) continue;
    const input = doc.createElement('input');
    input.type = 'hidden';
    input.name = k;
    input.value = String(v);
    form.appendChild(input);
  }
  return form;
}

export type ReturnStatus = 'success' | 'failure' | 'pending' | 'unknown';

export function classifyReturnStatus(status: string | null | undefined): ReturnStatus {
  if (!status) return 'unknown';
  const s = String(status).toLowerCase();
  if (['success', 'captured'].includes(s)) return 'success';
  if (['failure', 'failed', 'dropped', 'bounced', 'usercancelled', 'cancelled'].includes(s))
    return 'failure';
  if (['pending', 'initiated', 'in progress'].includes(s)) return 'pending';
  return 'unknown';
}

function escapeAttr(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}
